import { gql } from '@/apollo';

export const GET_CUSTOMERS = gql`
  query GetCustomers {
    customers {
      id
      name
      description
      isActive
      createdAt
      updatedAt
      providers {
        id
        firstName
        lastName
      }
      locations {
        id
      }
    }
  }
`;

export const GET_CUSTOMER = gql`
  query GetCustomer($id: ID!) {
    customer(id: $id) {
      id
      name
      description
      isActive
      createdAt
      updatedAt
      providers {
        id
        firstName
        lastName
      }
      locations {
        id
      }
    }
  }
`;

export const CREATE_CUSTOMER = gql`
  mutation CreateCustomer($input: CustomerCreateInput!) {
    createCustomer(input: $input) {
      id
      name
      description
      isActive
      createdAt
      updatedAt
      providers {
        id
        firstName
        lastName
      }
      locations {
        id
      }
    }
  }
`;

export const UPDATE_CUSTOMER = gql`
  mutation UpdateCustomer($id: ID!, $input: CustomerUpdateInput!) {
    updateCustomer(id: $id, input: $input) {
      id
      name
      description
      isActive
      createdAt
      updatedAt
      providers {
        id
        firstName
        lastName
      }
      locations {
        id
      }
    }
  }
`;

export const DELETE_CUSTOMER = gql`
  mutation DeleteCustomer($id: ID!) {
    deleteCustomer(id: $id)
  }
`;
